<small class="p-15 mat-small" fxFlex="" *ngIf="item.navCap">{{
        item.navCap
    }}</small>

<div class="top-border" *ngIf="item.route ? router.isActive(item.route, true) : false"></div>

<a mat-list-item [ngStyle]="{ 'padding-left': depth * 9 + 'px' }" (click)="onItemSelected(item)" [ngClass]="{
    activeMenu: item.route ? router.isActive(item.route, true) : false,
    expanded: expanded }" class="menu-list-item" *ngIf="!item.navCap"
   [class.selectedbg]="item.route ? router.isActive(item.route, true) : false"
   [routerLink]="item.route">

    <!-- <mat-icon aria-hidden="false" aria-label="Example home icon">{{item.iconName}}</mat-icon>  -->
    <i MatSuffix id="i1" *ngIf="item.iconName" class=" itemIcon flaticon-{{item.iconName}}"></i>

    <!-- icon change above -->
    <i MatSuffix *ngIf="item.icon" class="itemIcon flaticon-{{item.icon}}" [class.module]="depth==0"
       [class.menu]="depth>0"></i>
    <span class="hide-menu fs-12" *ngIf="item.module_name">{{ item.module_name }}</span>

    <span class="hide-menu fs-12" *ngIf="item.name">{{ item.name }}</span>

    <!-- //Static Menu List -->
    <span class="hide-menu fs-12" *ngIf="item.displayName">{{ item.displayName }}</span>

    <span class="arrow-icon" fxFlex *ngIf="item.menus && item.menus.length">
        <span fxFlex></span>
        <!-- <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
            expand_more
        </mat-icon> -->
        <i class="flaticon-down-chevron" [ngClass]="expanded? 'more':'' "></i>
    </span>
</a>

<div class="bottom-border" *ngIf="item.route ? router.isActive(item.route, true) : false"></div>

<div *ngIf="expanded">
    <app-menu-list-item *ngFor="let child of item.menus" [item]="child" [depth]="depth + 1">
    </app-menu-list-item>
</div>
